// extracted by mini-css-extract-plugin
export default {"wrapper":"Error_wrapper__lEAIi","homeLink":"Error_homeLink__jDR73"};